// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2JkhL";
export var icons = "footer-module--icons--IAvGF";
export var item = "footer-module--item--1mcZo";
export var items = "footer-module--items--3K5Pp";
export var list = "footer-module--list--1HMA_";
export var privacyOpen = "footer-module--privacy-open--1gyJG";
export var privacyPopupLink = "footer-module--privacy-popup-link--1TiVn";